import ErrorState from '@components/feedback/error-state';
import { FC } from 'react';

type Props = {
  reset: () => void;
};

const Error: FC<Props> = ({ reset }) => (
  <div className="flex h-full items-center justify-center">
    <ErrorState reset={reset} className="w-full" />
  </div>
);

export default Error;
